import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { getCollegeDetails } from "../../Services/HomeService";
import toast from "react-hot-toast";

import FormStepProgress from "../../Component/FormStepProgress ";
import CollegeUniversityAdmissionStep1 from "./Admission/CollegeUniversityAdmissionStep1";
import CollegeUniversityAdmissionStep2 from "./Admission/CollegeUniversityAdmissionStep2";
import CollegeUniversityAdmissionStep3 from "./Admission/CollegeUniversityAdmissionStep3";
import CollegeUniversityScholarshipStep1 from "./Scholarship/CollegeUniversityScholarshipStep1";
import CollegeUniversityScholarshipStep2 from "./Scholarship/CollegeUniversityScholarshipStep2";
import CollegeUniversityPlacementStep1 from "./Placement/CollegeUniversityPlacementStep1";
import CollegeUniversityPlacementStep2 from "./Placement/CollegeUniversityPlacementStep2";
import CollegeUniversityPlacementStep3 from "./Placement/CollegeUniversityPlacementStep3";
import CollegeUniversityPlacementStep4 from "./Placement/CollegeUniversityPlacementStep4";

const headLineStyle = {
  textAlign: "center",
  fontSize: "30px",
  color: "rgb(131, 144, 155)",
  margin: "0px 0px 10px 0px",
  fontWeight: "bold",
};

const CollegeUniversityPlacement = () => {
  const location = useLocation();
  const { college } = location.state || {};
  const [currentStep, setCurrentStep] = useState(1)
  const [data, setData] = useState(null)


  ////////////////////////////////////////////
  const transformData = (data) => {
    const transformObject = (obj) => {
      if (Array.isArray(obj)) {
        return obj.map(transformObject);
      } else if (obj && typeof obj === "object") {
        let newObj = { ...obj };

        // If course.category exists, create courseCategory as just the _id string
        if (newObj.course && newObj.course.category) {
          newObj.courseCategory = newObj.course.category._id;
          delete newObj.course.category;
        }

        // Recursively check other keys
        for (let key in newObj) {
          if (typeof newObj[key] === "object") {
            newObj[key] = transformObject(newObj[key]);
          }
        }
        return newObj;
      }
      return obj;
    };

    return transformObject(data);
  };

  ////////////////////////////////////////////

  const fetchCollegeDetails = async (id) => {
    try {
      const res = await getCollegeDetails(id);
      if (res?.status) {
        // setData(res?.data);
        const newData = transformData(res?.data);
        console.log("NDR74", newData);
        setData(newData);
      } else {
        toast.error("Error while Fetching College Data");
      }
    } catch (error) {
      toast.error("failed to fetch College Data");
      console.error("Error fetching College:", error);
    }
  };

  useEffect(() => {
    fetchCollegeDetails(college)
  }, [])

  const steps = {
    1: CollegeUniversityPlacementStep1,
    2: CollegeUniversityPlacementStep2,
    3: CollegeUniversityPlacementStep3,
    4: CollegeUniversityPlacementStep4
  };

  const StepComponent = steps[currentStep];
  const stepTab = [
    "Banner & Overview",
    "Report & Package",
    "Placement",
    "Comparison & Recruiters"
  ]

  return (
    <>
      <div className="main_wrap" style={{ marginTop: "6rem" }}>
        <div className="container-fluid">
          <div style={headLineStyle} className="page-headline">
            College/University Placement Tab
          </div>
          <FormStepProgress totalStep={4} currentStep={currentStep} setCurrentStep={setCurrentStep} stepTab={stepTab} />
          {StepComponent && (
            <StepComponent
              data={data}
              setData={setData}
              setCurrentStep={setCurrentStep}
              currentStep={currentStep}
            />
          )}
        </div>
      </div >
    </>
  );
};

export default CollegeUniversityPlacement;
